import axios, { AxiosResponse } from "axios";
import { configService } from "./config.service";

class CypressService {
  async deleteAllTestDuties(): Promise<any> {
    return new Promise((resolve, reject) => {
      axios
        .get<any>(configService.APIInstitutionUrl("delete_all_test_duties.json"))
        .then((response: AxiosResponse) => {
          resolve(response.data);
        })
        .catch((error) => reject(error));
    });
  }

  async deleteAllTestEvents(): Promise<any> {
    return new Promise((resolve, reject) => {
      axios
        .get<any>(configService.APIInstitutionUrl("delete_all_test_events.json"))
        .then((response: AxiosResponse) => {
          resolve(response.data);
        })
        .catch((error) => reject(error));
    });
  }

  async deleteAllTestAbsences(): Promise<any> {
    return new Promise((resolve, reject) => {
      axios
        .get<any>(configService.APIInstitutionUrl("delete_all_test_absences.json"))
        .then((response: AxiosResponse) => {
          resolve(response.data);
        })
        .catch((error) => reject(error));
    });
  }
}

export const cypressService: CypressService = new CypressService();
